const MAX_DIAGNOSTIC_BYTES = 10 * 1024;

function isDiagnosticsEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'test') {
    return false;
  }

  return import.meta.env.VITE_FRONTEND_DIAGNOSTICS_ENABLED === 'true';
}

function getDiagnosticsUrl() {
  const baseUrl = import.meta.env.VITE_API_URL || '/api';
  return `${baseUrl.replace(/\/+$/, '')}/diagnostics/frontend`;
}

function buildBaseEvent(eventType, fields = {}) {
  return {
    eventType,
    dt: new Date().toISOString(),
    route: window.location?.pathname || null,
    visibility: document.visibilityState || null,
    online: navigator.onLine,
    ...fields
  };
}

export function emitFrontendDiagnostic(eventType, fields = {}, options = {}) {
  if (!isDiagnosticsEnabled()) {
    return false;
  }

  const event = buildBaseEvent(eventType, fields);
  const body = JSON.stringify(event);

  if (body.length > MAX_DIAGNOSTIC_BYTES) {
    return false;
  }

  const url = getDiagnosticsUrl();

  try {
    if (options.useBeacon && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      return navigator.sendBeacon(url, blob);
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body,
      credentials: 'include',
      keepalive: true
    }).catch(() => {});

    return true;
  } catch (_) {
    return false;
  }
}
